import React, { memo } from "react";

import { SkeletonLoader } from "@whoosh/design-system/src/components/display";
import { HStack, VStack } from "@whoosh/design-system/src/components/primitive";

export const BookingSummaryHeaderSkeleton = memo(() => (
  <HStack
    justifyContent="space-between"
    testID="booking-summary-skeleton-header"
    alignItems="center"
  >
    <SkeletonLoader
      testID="booking-summary-skeleton-header-avatar"
      height={56}
      width={56}
      borderRadius="1"
    />
    <VStack gap={1} alignItems="center">
      <SkeletonLoader
        testID="booking-summary-skeleton-header-title"
        height={16}
        width={130}
        borderRadius="1"
      />
      <SkeletonLoader
        testID="booking-summary-skeleton-header-title"
        height={16}
        width={180}
        borderRadius="1"
      />
    </VStack>

    <SkeletonLoader
      testID="booking-summary-skeleton-header-avatar"
      height={56}
      width={56}
      borderRadius="1"
    />
  </HStack>
));
